import { Cell } from "react-table";
import { BaseTooltip } from "src/components/BaseTooltip";
import { AccessLogsResponse, findAccessTypeToString } from "../../access-record-types";
import moment from "moment";
import { ViewYmdFormat } from "src/utils";
import { getContractDetailPath } from "src/utils/route-util";
import BaseNewTabLink from "src/components/BaseNewTabLink";
import pagePath from "src/pagePath.json";

const columns: any = [
  {
    Header: "이벤트 발생일시",
    accessor: "datetime",
    sticky: "left",
    width: 160,
    Cell: ({ row, value }: Cell<AccessLogsResponse>) => {
      return <p className="w-100 text-center">{value ? moment(value).format(ViewYmdFormat.FULL) : "-"}</p>;
    },
    excelValue: (row: AccessLogsResponse) => {
      return row.datetime ? moment(row.datetime).format(ViewYmdFormat.FULL) : "-";
    },
  },
  {
    Header: "이벤트",
    accessor: "eventName",
    sticky: "left",
    width: 200,
    Cell: ({ row, value }: Cell<AccessLogsResponse>) => {
      return <p className="w-100 text-left email ellipsis">{value || "-"}</p>;
    },
  },
  {
    Header: "인증 유형",
    accessor: "accessType",
    sticky: "left",
    width: 160,
    Cell: ({ row, value }: Cell<AccessLogsResponse>) => {
      return <p className="w-100 text-center">{findAccessTypeToString(value) || "-"}</p>;
    },
    excelValue: (row: AccessLogsResponse) => {
      return findAccessTypeToString(row?.accessType || "-");
    },
  },
  {
    Header: "장치명",
    accessor: "deviceName",
    width: 200,
    sticky: "left",
    Cell: ({ row, value }: Cell<AccessLogsResponse>) => {
      return <p className="text-left w-100 ellipsis2">{value || "-"}</p>;
    },
  },
  {
    Header: () => (
      <div className="d-flex flex-center">
        <span>계약명</span>
        <BaseTooltip touchIcon={"QUESTION"} size={16} className="ml4" contents={`계약명이 없는 경우 상품명이 표시됩니다.`} />
      </div>
    ),
    accessor: "contractManageIds",
    width: 280,
    Cell: ({ row, value }: Cell<AccessLogsResponse>) => {
      return (
        <div className="w-100 text-left">
          {value?.map(
            (contractIds: { contractId: string; contractManageId: string; contractName: string; spaceProductName: string }, idx: number) => (
              <BaseNewTabLink
                key={crypto.randomUUID()}
                path={getContractDetailPath({ contractId: contractIds?.contractId })}
                value={contractIds?.contractName || contractIds.spaceProductName || "-"}
                suffix={<>{value?.length - 1 !== idx && <span>, </span>}</>}
              ></BaseNewTabLink>
            ),
          )}
        </div>
      );
    },
  },
  {
    Header: "이용자 닉네임",
    accessor: "nickname",
    width: 200,
    Cell: ({ row, value }: Cell<AccessLogsResponse>) => {
      return <p className="w-100 text-left break-all">{value || "-"}</p>;
    },
  },
  {
    Header: "이메일",
    accessor: "email",
    width: 200,
    Cell: ({ row, value }: Cell<AccessLogsResponse>) => {
      return <p className="w-100 text-left break-all">{value || "-"}</p>;
    },
  },
  {
    Header: "회원번호",
    accessor: "userId",
    width: 120,
    Cell: ({ row, value }: Cell<AccessLogsResponse>) => {
      const isUserType = row.original.userType === "MEMBER";
      return (
        <div className="w-100 text-left email ellipsis">
          {value && isUserType ? (
            <BaseNewTabLink path={pagePath.user.list + `?size=20&page=0&searchType=MEMBER_NO&searchValue=${value}`} value={value}></BaseNewTabLink>
          ) : (
            "-"
          )}
        </div>
      );
    },
    excelValue: (row: AccessLogsResponse) => {
      return row.userType === "MEMBER" ? row.userId : "-";
    },
  },
  {
    Header: "방문자 ID",
    accessor: "userId2",
    width: 120,
    Cell: ({ row, value }: Cell<AccessLogsResponse>) => {
      const isUserType = row.original.userType === "VISITOR";
      const userId = row.original.userId;
      const visitorInfo = row.original.visitorInfo;
      return (
        <div className="w-100 text-left email ellipsis">
          {isUserType ? (
            <BaseNewTabLink
              path={pagePath.visitor.detail
                .replace(":visitApplyNumber", visitorInfo.visitApplyNumber)
                .replace(":contractApplyNumber", visitorInfo.contractApplyNumber)}
              value={userId || "-"}
            ></BaseNewTabLink>
          ) : (
            "-"
          )}
        </div>
      );
    },
    excelValue: (row: AccessLogsResponse) => {
      return row.userType === "VISITOR" ? row.userId : "-";
    },
  },
];

export default columns;
